import './index.css'

import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Header from '../../Header'
import CheckboxGroup from '../../CheckboxGroup'
import InputDisabled from '../../InputDisabled'
import ArrowDownSvg from '../../../assets/icons/ArrowDownSvg'
import IlceModal from './Modals/IlceModal'
import MahalleModal from './Modals/MahalleModal'
import ConditionsCheckBox from '../ApplicationsForm/ConditionsCheckBox'
import { Button } from 'reactstrap'
import TubitakWarningModal from './Modals/TubitakWarningModal'
import axios from 'axios'
import LoadingAbsolute from '../../LoadingAbsolute'
import InputComp from '../../InputComp'
import SchollModal from './Modals/SchollModal'

const ESporBasvuruForm = (props) => {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [labelAddress, setLabelAddress] = useState('')
  const [selectedAddress, setSelectedAdress] = useState(
    labelAddress === '' ? 'yeni' : 'ikametgah'
  )
  const [selectedIlce, setSelectedIlce] = useState('KARATAY')
  const [selectedSchool, setSelectedSchool] = useState('Seçiniz...')
  const [selectedSchoolId, setSelectedSchoolId] = useState(null)
  const [selectedMahalle, setSelectedMahalle] = useState('Seçiniz...')
  const [selectedMahalleId, setSelectedMahalleId] = useState(null)
  const [ilceModalOpen, setIlceModalOpen] = useState(false)
  const [schoolModalOpen, setSchoolModalOpen] = useState(false)
  const [mahalleModalOpen, setMahalleModalOpen] = useState(false)
  const [warningModalOpen, setWarningModalOpen] = useState({
    state: '',
    active: false,
    message: '',
  })
  const [secondAdress, setSecondAdress] = useState('')
  const [checkbox, setCheckbox] = useState(false)
  const [mahalleLabelClass, setMahalleLabelClass] = useState('selectLabel')
  const [schoolLabelClass, setSchoolLabelClass] = useState('selectLabel')
  const [adressLabelClass, setAdressLabelClass] = useState('selectLabel')
  const [mahalleInputClass, setMahalleInputClass] = useState('selectInput')
  const [schoolInputClass, setSchoolInputClass] = useState('selectInput')
  const [adressInputClass, setAdressInputClass] = useState('selectTextArea')
  const [otherInputClass, setOtherInputClass] = useState('selectTextArea')
  const [mahalleler, setMahalleler] = useState(null)
  const [ilceler, setIlceler] = useState(null)
  const [labelName, setLabelName] = useState(null)
  const [labelSurname, setLabelSurname] = useState(null)
  const [labelPhone, setLabelPhone] = useState(null)
  const [labelEposta, setLabelEposta] = useState(null)
  const [isIkametgah, setIsIkametgah] = useState(false)
  const [veliPhone, setVeliPhone] = useState('')
  const [InputDate, setInputDate] = useState('')

  const [InputPhoneError, setInputPhoneError] = useState(false)

  const [games, setGames] = useState([])
  const [otherInput, setOtherInput] = useState(false)
  const [otherGame, setOtherGame] = useState('')

  const onInit = () => {
    axios
      .get('https://app.yanibasimdakaratay.com/api/dijital_basvuru/e-spor', {
        params: {
          token: JSON.parse(localStorage.getItem('token')),
        },
      })
      .then((res) => {
        setIlceler(res.data.ilceler)
        setMahalleler(res.data.mahalleler)

        setLabelName(res.data.adi)
        setLabelSurname(res.data.soyadi)
        setLabelPhone(res.data.eposta)
        setLabelEposta(res.data.telefon_no)
        setInputDate(res.data.dogum_tarihi)
        setLabelAddress(res.data.ikametgah)
        setIsIkametgah(res.data.ikametgah ? false : true)
        setSelectedAdress(res.data.ikametgah ? 'ikametgah' : 'yeni')
        setLoading(false)
      })
  }

  useEffect(() => {
    onInit()
  }, [])

  const onFinish = () => {
    let error = false

    console.log('otherGame?.length:', otherGame?.length)
    if (otherGame?.length > 1) {
      setOtherInputClass('selectTextArea')
    } else {
      setOtherInputClass('unSelectInput')
    }

    if (selectedSchoolId) {
      setSchoolInputClass('selectInput')
      setSchoolLabelClass('selectLabel')
    } else {
      setSchoolInputClass('unSelectInput')
      setSchoolLabelClass('unSelectLabel')
      error = true
    }

    if (veliPhone?.length < 15) {
      setInputPhoneError(true)
      error = true
    } else {
      setInputPhoneError(false)
    }

    if (error) {
      return false
    }

    if (selectedAddress === 'yeni') {
      if (selectedIlce === 'KARATAY' && selectedMahalle === 'Seçiniz...') {
        setMahalleInputClass('unSelectInput')
        setMahalleLabelClass('unSelectLabel')
      } else {
        setMahalleInputClass('selectInput')
        setMahalleLabelClass('selectLabel')
      }

      if (secondAdress?.length >= 10) {
        setAdressInputClass('selectTextArea')
        setAdressLabelClass('selectLabel')
      } else {
        setAdressInputClass('unSelectInput')
        setAdressLabelClass('unSelectLabel')
      }

      if (
        !checkbox &&
        secondAdress?.length >= 10 &&
        (selectedIlce === 'KARATAY' ? selectedMahalleId : true) &&
        veliPhone?.length === 15
      ) {
        setWarningModalOpen({ state: 'checkbox', active: true })
      } else if (
        checkbox &&
        secondAdress?.length >= 10 &&
        (selectedIlce === 'KARATAY' ? selectedMahalleId : true)
      ) {
        if (games?.length < 1 && otherInput === false) {
          setWarningModalOpen({ state: 'games', active: true })
        } else {
          formCompleted()
        }
      }
    } else {
      if (!checkbox) {
        setWarningModalOpen({ state: 'checkbox', active: true })
      } else {
        if (games?.length < 1 && otherInput === false) {
          setWarningModalOpen({ state: 'games', active: true })
        } else {
          formCompleted()
        }
      }
    }
  }
  const formCompleted = () => {
    let getGames = games
    console.log('formCompleted')
    // Her şey Tamamlanınca başvuruyu yap

    if (otherInput === true) {
      getGames = [...games, otherGame]
    }

    if (getGames?.length > 0) {
      if (otherInput) {
        console.log('getGames: ', [...getGames])
      } else {
        console.log(
          'games: ',
          getGames?.filter((item) => item !== otherGame)
        )
      }
    }

    setLoading(true)
    axios
      .post('https://app.yanibasimdakaratay.com/api/dijital_basvuru/e-spor', {
        token: JSON.parse(localStorage.getItem('token')),
        id: state?.basvuru_id,
        adres: labelAddress,
        veli_telefonu: veliPhone,
        egitim_durumu: selectedSchool,
        oynadiginiz_oyunlar: JSON.stringify(getGames),
        ...(selectedAddress === 'yeni'
          ? {
              adres_type: 'yeni_adres',
              ilce: selectedIlce,
              mahalle: selectedMahalle,
              adres: secondAdress,
            }
          : {
              adres_type: 'ikametgah',
            }),
      })
      .then((res) => {
        setLoading(false)
        if (res.data.code === 200) {
          navigate('/success-applications', {
            state: { id: res.data.basvuru_no },
          })
        } else if (res.data.code === 400) {
          setWarningModalOpen({
            state: 'responseMessage',
            active: true,
            message: res.data.message,
          })
        }
      })
  }

  return (
    <>
      {loading ? <LoadingAbsolute text={'Yükleniyor'} /> : null}
      <div className='hide-scrollbar'>
        <div
          style={{
            backgroundColor: '#fff',
            position: 'sticky',
            top: 0,
          }}
        >
          <Header onClick={() => navigate(-1)} />
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src={
              'https://app.yanibasimdakaratay.com/uploads/dijital_basvurular/' +
              state?.basvuru_fotografi
            }
            alt=''
            width={'90%'}
            height={'100%'}
            style={{ borderRadius: '10px' }}
          />
        </div>

        <div className='divider' />

        <>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
            }}
          >
            <div className='userInfoDiv'>
              <InputDisabled label={'Adınız'} value={labelName} half />
              <InputDisabled label={'Soyadınız'} value={labelSurname} half />
              <InputDisabled label={'Epostanız'} value={labelEposta} />
              <InputDisabled label={'Telefonunuz'} value={labelPhone} />
              <InputDisabled label={'Doğum Tarihiniz'} value={InputDate} />
            </div>

            <div className='userInfoDiv'>
              <InputComp
                label={' Veli Telefon Numarası'}
                type='tel'
                value={veliPhone}
                maxlength='11'
                onChange={(e) => {
                  const regex = /^[0-9.]*$/

                  if (
                    !regex.test(e.target.value) &&
                    e.target.value?.length <= 14
                  ) {
                    setVeliPhone(
                      e.target.value
                        .replace(/[^0-9]/g, '')
                        .replace(
                          /(\d{3})(\d{3})(\d{2})(\d{2})/g,
                          '($1) $2 $3 $4'
                        )
                    )
                    setInputPhoneError(false)
                  } else {
                    setVeliPhone(
                      e.target.value
                        .replace(/[^0-9]/g, '')
                        .replace(
                          /(\d{3})(\d{3})(\d{2})(\d{2})/g,
                          '($1) $2 $3 $4'
                        )
                    )
                    setInputPhoneError(false)
                  }
                }}
                placeholder='Örn: (555) 555 55 55'
                error={InputPhoneError}
              />
            </div>

            <div className='userInfoDiv' style={{ marginTop: 10 }}>
              <div
                style={{
                  width: '100%',
                }}
              >
                <div className={schoolLabelClass}>Eğitim Durumu</div>
                <div
                  className={schoolInputClass}
                  onClick={() => setSchoolModalOpen(true)}
                >
                  <div>{selectedSchool}</div>{' '}
                  <ArrowDownSvg
                    width={'1rem'}
                    height={'1rem'}
                    stroke={
                      schoolInputClass === 'unSelectInput' ? 'red' : '#b5ccc2'
                    }
                  />
                </div>
              </div>
              {schoolInputClass === 'unSelectInput' && (
                <div
                  style={{
                    marginTop: '-0.3rem',
                    marginLeft: '0.5rem',
                    fontSize: '9px',
                    color: 'red',
                  }}
                >
                  Bu Alan Zorunludur.
                </div>
              )}
            </div>

            {selectedAddress === 'ikametgah' && (
              <div
                style={{
                  marginLeft: '1.3rem',
                  marginRight: '0.5rem',
                  width: '98%',
                }}
              >
                <InputDisabled
                  label={'İkamet Adresiniz'}
                  value={labelAddress}
                  textArea={true}
                />
              </div>
            )}
          </div>

          {!isIkametgah && (
            <CheckboxGroup
              style={{ margin: '1rem 0 0  1rem' }}
              title={'Adresiniz'}
              label1={'İkametgah Adresim'}
              label2={'Yeni Adres'}
              value1={'ikametgah'}
              value2={'yeni'}
              selectedValue={selectedAddress}
              setSelectedValue={setSelectedAdress}
              address={true}
            />
          )}
          {selectedAddress === 'yeni' && (
            <>
              <div
                style={{
                  padding: '1rem 1.5rem',
                }}
              >
                <div
                  className='selectInputDiv'
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '0.4rem',
                  }}
                >
                  <div
                    style={{
                      width: '100%',
                    }}
                  >
                    <div className='selectLabel'>İlçe</div>
                    <div
                      className='selectInput'
                      onClick={() => setIlceModalOpen(true)}
                    >
                      <div>{selectedIlce}</div>{' '}
                      <ArrowDownSvg width={'1rem'} height={'1rem'} />
                    </div>
                  </div>

                  {selectedIlce === 'KARATAY' && (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                      }}
                    >
                      <div>
                        <div className={mahalleLabelClass}>Mahalle</div>
                        <div
                          className={mahalleInputClass}
                          onClick={() => setMahalleModalOpen(true)}
                        >
                          <div>{selectedMahalle}</div>
                          <ArrowDownSvg
                            width={'1rem'}
                            height={'1rem'}
                            stroke={
                              mahalleInputClass === 'unSelectInput'
                                ? 'red'
                                : '#b5ccc2'
                            }
                          />
                        </div>
                      </div>
                      {mahalleInputClass === 'unSelectInput' && (
                        <div
                          style={{
                            marginTop: '0.1rem',
                            marginLeft: '0.5rem',
                            fontSize: '9px',
                            color: 'red',
                          }}
                        >
                          Bu Alan Zorunludur.
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div
                style={{
                  marginLeft: '1.5rem',
                  marginRight: '0.5rem',
                }}
              >
                <div className={adressLabelClass}>Adresiniz</div>
                <textarea
                  className={adressInputClass}
                  value={secondAdress}
                  onChange={(e) => {
                    if (e.target.value?.length >= 10) {
                      setAdressInputClass('selectTextArea')
                      setAdressLabelClass('selectLabel')
                    }
                    setSecondAdress(e.target.value)
                  }}
                  rows='3'
                  placeholder='Cadde, sokak, site/bina adı, daire numarasını eksiksiz olarak giriniz...'
                ></textarea>
                {adressInputClass === 'unSelectInput' && (
                  <div
                    style={{
                      marginTop: '0.1rem',
                      marginLeft: '0.5rem',
                      fontSize: '9px',
                      color: 'red',
                    }}
                  >
                    {secondAdress?.length === 0
                      ? 'Bu Alan Zorunludur.'
                      : 'En az 10 karakter olmalıdır.'}
                  </div>
                )}
              </div>
            </>
          )}

          <div
            className='userInfoDiv'
            style={{
              display: 'flex',
              flexDirection: 'column',
              margin: '0.5rem 0 0 0',
            }}
          >
            <div
              className='selectLabel'
              style={{ marginTop: '0.5rem', marginBottom: '0.3rem' }}
            >
              {'Oynadığınız Oyunlar'}
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: 5,
              }}
            >
              <input
                type='checkbox'
                id='pubg_mobile'
                name='vehicle1'
                value='pubg_mobile'
                style={{
                  width: '16px',
                  height: '16px',
                }}
                onChange={(e) => {
                  if (e.target.checked) {
                    setGames((prevState) => [...prevState, e.target.value])
                  } else {
                    const newGames = games?.filter(
                      (item) => item !== e.target.value
                    )
                    setGames(newGames)
                  }
                }}
              />
              <label
                htmlFor='pubg_mobile'
                className='gameCheckboxLabel'
                style={{ fontWeight: '500' }}
              >
                PUBG Mobile
              </label>
              <br />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: 5,
              }}
            >
              <input
                type='checkbox'
                id='valorant'
                name='vehicle2'
                value='valorant'
                style={{ width: '16px', height: '16px' }}
                onChange={(e) => {
                  if (e.target.checked) {
                    setGames((prevState) => [...prevState, e.target.value])
                  } else {
                    const newGames = games?.filter(
                      (item) => item !== e.target.value
                    )
                    setGames(newGames)
                  }
                }}
              />
              <label
                htmlFor='valorant'
                className='checkboxLabel'
                style={{ fontWeight: '500' }}
              >
                Valorant
              </label>
              <br />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: 5,
              }}
            >
              <input
                type='checkbox'
                id='league_of_legends'
                name='vehicle3'
                value='league_of_legends'
                style={{ width: '16px', height: '16px' }}
                onChange={(e) => {
                  if (e.target.checked) {
                    setGames((prevState) => [...prevState, e.target.value])
                  } else {
                    const newGames = games?.filter(
                      (item) => item !== e.target.value
                    )
                    setGames(newGames)
                  }
                }}
              />
              <label
                htmlFor='league_of_legends'
                className='gameCheckboxLabel'
                style={{ fontWeight: '500' }}
              >
                League of Legends
              </label>
              <br />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: 5,
              }}
            >
              <input
                type='checkbox'
                id='other'
                name='vehicle4'
                value='other'
                style={{ width: '16px', height: '16px' }}
                onChange={(e) => {
                  if (e.target.checked) {
                    setOtherInput(true)
                  } else {
                    setOtherInput(false)
                  }
                }}
              />
              <label
                htmlFor='other'
                className='gameCheckboxLabel'
                style={{ fontWeight: '500' }}
              >
                Diğer
              </label>
              <br />
            </div>
            {otherInput && (
              <>
                <textarea
                  className={otherInputClass}
                  value={otherGame}
                  onChange={(e) => {
                    if (e.target.value?.length >= 1) {
                      setOtherInputClass('selectTextArea')
                    }
                    setOtherGame(e.target.value)
                  }}
                  rows='3'
                  placeholder='Diğer oyunların isimlerini giriniz...'
                ></textarea>
                {otherInputClass === 'unSelectInput' && (
                  <div
                    style={{
                      marginTop: '-0.3rem',
                      marginLeft: '0.5rem',
                      fontSize: '9px',
                      color: 'red',
                    }}
                  >
                    {otherGame?.length === 0 && 'Bu Alan Zorunludur.'}
                  </div>
                )}
              </>
            )}
          </div>

          <>
            <div
              style={{
                marginLeft: '0.5rem',
                marginRight: '0.5rem',
                marginTop: '1rem',
              }}
            >
              <ConditionsCheckBox
                checkbox={checkbox}
                setCheckbox={setCheckbox}
                basvuru_sartlari_title={state?.basvuru_sartlari_title}
                basvuru_sartlari_aciklama={state?.basvuru_sartlari_aciklama}
              />
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '1rem',
                marginBottom: '2rem',
              }}
            >
              <Button
                block
                className='tubitakTamamla'
                onClick={onFinish}
                style={{
                  marginLeft: '1rem',
                  marginRight: '1rem',
                  backgroundColor: '#285843',
                  borderRadius: '20px',
                  padding: '0.6rem 0',
                }}
              >
                Başvuruyu Tamamla
              </Button>
            </div>
          </>
        </>
        <SchollModal
          show={schoolModalOpen}
          onHide={() => setSchoolModalOpen(false)}
          setSelectedSchool={setSelectedSchool}
          setSelectedSchoolId={setSelectedSchoolId}
          setSchoolClass={() => {
            setSchoolInputClass('selectInput')
            setSchoolLabelClass('selectLabel')
          }}
        />

        {ilceler ? (
          <IlceModal
            show={ilceModalOpen}
            onHide={() => setIlceModalOpen(false)}
            setIlce={setSelectedIlce}
            setMahalleAdi={setSelectedMahalle}
            setMahalleid={setSelectedMahalleId}
            ilceler={ilceler}
          />
        ) : null}

        {mahalleler ? (
          <MahalleModal
            show={mahalleModalOpen}
            onHide={() => setMahalleModalOpen(false)}
            setMahalleAdi={setSelectedMahalle}
            setMahalleid={setSelectedMahalleId}
            mahalleler={mahalleler}
            setMahalleClass={() => {
              setMahalleInputClass('selectInput')
              setMahalleLabelClass('selectLabel')
            }}
          />
        ) : null}
        <TubitakWarningModal
          show={warningModalOpen.active}
          onHide={() => setWarningModalOpen({ state: '', active: false })}
          state={warningModalOpen.state}
          message={warningModalOpen.message}
          secondadress={
            selectedAddress === 'yeni' ? secondAdress : labelAddress
          }
          selectedadress={selectedAddress}
          ogrenciBasvuruOnClick={() => {}}
        />
      </div>
    </>
  )
}

export default ESporBasvuruForm
